// extracted by mini-css-extract-plugin
module.exports = {"illustration":"PageContent_illustration__h_LSN","results":"PageContent_results__gUgp_"};